export default "__VITE_ASSET__f_BUn4mU__"